import {Component, Injector, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {TechnicalDeviceElementApiService} from '@api/technical-device-element.api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {distinctUntilChanged, skip} from 'rxjs/operators';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {DynamicFieldsGroupComponent} from '@subforms/dynamic-fields/components/dynamic-fields-group/dynamic-fields-group.component';
import {FormArray} from '@angular/forms';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-element-form',
    templateUrl: './element-form.component.html',
})
export class ElementFormComponent extends FrontendFormComponent implements OnDestroy {

    public afterSaveMessage = NotyMessagesEnum.technicalDeviceElementUpdatedMessage;

    public technicalDevice: TechnicalDeviceNamespace.ApiDataInterface;

    public orderTypes = TechnicalDeviceNamespace.ElementControlOrderFormTypes;
    public orderValues = TechnicalDeviceNamespace.ElementControlOrderFormRadioValues;

    public form = this._fb.group({
        group_id: [''],
        number: [''],
        params: this._fb.array([]),
        control_order_state: [this.orderTypes.noOrder],
        order: [],
        control_order_id: [''],
    });

    public deviceUrl: string;



    public groups: TechnicalDeviceNamespace.ElementGroupSelectInterface[] = [];

    @ViewChild(DynamicFieldsGroupComponent) paramsFields: DynamicFieldsGroupComponent;

    constructor(
        injector: Injector,
        public formService: TechnicalDeviceElementApiService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        super(injector);
    }

    init() {
        this.technicalDevice = this.route.snapshot.data.technicalDevice;
        this.groups = this.route.snapshot.data.elementGroupsWithParams || [];

        if (this.technicalDevice) {
            this.deviceUrl = RoutesStorage.TechnicalDevice.viewElements(this.technicalDevice.id);
        }

        this.paramsFields.fbArray = this.form.get('params') as FormArray;

        this.form.get('group_id').valueChanges.pipe(
            distinctUntilChanged(),
            skip(1),
            untilDestroyed(this)
        ).subscribe((group_id) => {
            this.paramsFields.setGroupStructure(this.getGroupParams());
        });

        this.form.get('group_id').updateValueAndValidity();
    }

    getGroupParams() {
        const value = +this.form.get('group_id').value;
        if (!value || !this.groups || !this.groups.length) {
            return [];
        }

        const group = this.groups.find(g => g.id === value);
        return group && group.params || [];
    }

    afterSave() {
        super.afterSave();
        this.isPending = true;
        this.router.navigate([this.deviceUrl]);
    }

    ngOnDestroy(): void {

    }
}
